import * as React from 'react';

import { FormControlLabel, Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { Enum } from '@ha/utilities/Enum';

import { Furnishings } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';

import { Checkbox } from '@kamernet/components/FormFields/final-form/Checkbox/CheckboxInput';
import { FurnishingLabelTranslations } from '@kamernet/modules/Listing/translations';

import { SideFiltersFormFieldStyles } from './SideFiltersFormFieldStyles';

export const FurnishingsFormField = () => {
  const { T } = useIntl();
  return (
    <React.Fragment>
      <Typography variant="h4">{T('LBL_FURNISHING')}</Typography>
      <section className={SideFiltersFormFieldStyles.controlsGroupColumn}>
        {Enum.values(Furnishings).map(furnishing => (
          <FormControlLabel
            key={furnishing}
            control={
              <Field<number>
                name="furnishings"
                component={Checkbox}
                type="checkbox"
                value={furnishing}
              />
            }
            label={T(FurnishingLabelTranslations[furnishing])}
          />
        ))}
      </section>
    </React.Fragment>
  );
};
